import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   ak: '5a5mYi83sMCOP3NXv2iw8sKLYu511eo8'
// });

Vue.use(ElementUI);
Vue.config.productionTip = false



new Vue({
  el:'#app',
  //配置路由
  router,
  comments:{App},
  render: h => h(App),
}).$mount('#app')




// const proxyObj = {}
// proxyObj['/'] = {
//   target: 'http://localhost:8899',
//   changeOrigin: true,
//   pathRewrite: {
//     '^/': ''
//   }
// }
// module.exports = {
//   devServer: {
//     host: 'localhost',
//     port: 80,
//     proxy: proxyObj
//   }
// }

